import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';

import { GroupsPlaceholder } from '@gem/components';
import { customScrollStyles } from '@gem/ui-kit';

import { List } from 'APP/components/List/List';

import User from '../../components/User';
import styles from './styles.m.scss';

export const UserSeenList = observer(({ list }) => {
  const renderItem = useCallback((user) => {
    return (
      <User
        user={user}
        ignoreIsMe
      />
    );
  }, []);

  return (
    <div className={classNames(styles.container, customScrollStyles.container)}>
      <List
        isLoading={list.isLoading}
        hasMore={list.hasMore}
        data={list.users}
        onEndReached={list.loadMore}
        keyExtractor={(user) => user.userId}
        renderItem={renderItem}
        SpinnerComponent={
          <GroupsPlaceholder
            count={10}
            className={styles.placeholders}
          />
        }
      />
    </div>
  );
});
